import React, {useContext} from 'react';
import Header from '../../Utils/Header'
import Footer from '../../Utils/Footer'
import recuperar from '../../images/recuperar.png'
import CredencialesContext from '../../Context/CredencialesContext/CredencialesContext';

const Recuperar = () => {

    //EXTRAER CONTEXT LOGIN
    const login_context = useContext(CredencialesContext);
    const { correo_recuperar, alerta_recuperar, alerta_recuperar_str, Alerta_Str_F, Correo_Recuperar_F, Enviar_Recuperar_F, Alerta_Recuperar_F, enviar_recuperar } = login_context;

    const RecuperarF = e =>{
        e.preventDefault();
        Correo_Recuperar_F({
        ...correo_recuperar,
        [e.target.name]: e.target.value
        });
    }

    const RecuperarSubmitF = e =>{
        e.preventDefault();

        if(correo_recuperar.usuario !== '' && correo_recuperar.usuario !== undefined){
            Enviar_Recuperar_F(true)
            Alerta_Recuperar_F(false)
        }else{
            Alerta_Str_F('Ingrese correo o usuario.')
            Alerta_Recuperar_F(true)
        }
    }

    return ( 

        <>
        <Header/>
            <div className="container-fluid bg-light py-5">
                <div className="row ">
                    <div className="col-12 col-md-6 d-none d-md-block mt-5 ">
                        <img src={recuperar} alt="recuperar" className="img-fluid mx-auto mt-5" />
                    </div>
                    <div className="col-12 col-md-6  ">
                        <h2 className="lead">RECUPERAR CLAVE</h2>
                        <form className="d-block" onSubmit={RecuperarSubmitF}>
                            <div className="form-group">
                                <label htmlFor="usuario">Nombre de usuario o email</label>
                                <input type="text" className="form-control col-12 col-md-5" id="usuario" onChange={RecuperarF} name="usuario"/>
                            </div>
                            <button type="submit" className="btn btn-primary mb-2 btn-send">Recuperar</button>
                            {enviar_recuperar ? 
                                <div className="ml-2 spinner-grow text-primary" role="status">
                                    <span className="sr-only">Loading...</span>
                                </div>
                            :null}
                        </form>


                        {alerta_recuperar ? 
                            <div className="alert alert-info col-12 col-md-5 text-center" role="alert">
                                <strong>{alerta_recuperar_str}</strong>
                            </div>
                        :null}

                    </div>
                </div>
            </div>
        <Footer/>
        </>

     );
}
 
export default Recuperar;